import React from "react"
import { StyleProp, ViewStyle } from "react-native"

import styled from "styled-components/native"

import { Blurhash } from "./blurhash"

const BlurhashContainer = styled.View`
  position: absolute;
  width: 100%;
  height: 100%;
`

const BlurhashOverlay = styled.View`
  position: absolute;
  background-color: #000000;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.3;
`

export function BlurhashWithOverlay({
  style,
  ...blurhashProps
}: Parameters<typeof Blurhash>[0] & { style?: StyleProp<ViewStyle> }) {
  return (
    <BlurhashContainer style={style}>
      <Blurhash {...blurhashProps} />
      <BlurhashOverlay />
    </BlurhashContainer>
  )
}
